import { Inject, Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {APP_BASE_HREF} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: any;
  private bh: string;
  constructor(@Inject(APP_BASE_HREF)_baseHref: string,private http: HttpClient) {
    this.bh = _baseHref.replace('/it/','/');
    this.bh = this.bh.replace('/en/','/')
   }

  public loadConfig(resolve: any, reject:any) {
    return this.http
      .get(this.bh+'assets/config/config.json')
      .subscribe({
        next: (config: any) => {
          this.config = config;
          resolve()
        },
        error: (err: any) => {
          console.error(err);
          reject()
        }
      })
  }
  getConfig() {
    return this.config;
  }
}
